import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Hero from './Hero';
import Benefits from './Benefits';
import Features from './Features';
import Testimonials from './Testimonials';
import SignupForm from './SignupForm';
import Footer from './Footer';

const LandingPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // Store data in localStorage for demo purposes
    localStorage.setItem('signupData', JSON.stringify(formData));
    
    setIsSubmitting(false);
    navigate('/thank-you');
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50"
    >
      <Hero />
      <Benefits />
      <Features />
      <Testimonials />
      <SignupForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />
      <Footer />
    </motion.div>
  );
};

export default LandingPage;